import { Api } from "../config/request";

export default {
  getFeatureToggleList(payload) {
    return Api.post("/feature/toggle/list", payload);
  },
  getFeatureToggle(payload) {
    return Api.post("/feature/toggle/detail", payload);
  },
  createFeatureToggle(url, payload) {
    return Api.post(url, payload);
  },
  getFeatureToggleEnabled(url, payload) {
    return Api.post(url, payload);
  },
  getBulkDeleteUrl(payload) {
    return Api.post(`/feature/toggle/bulk-delete`, payload);
  },
};
